module.exports = __webpack_public_path__ + "static/img/bottom_banner.65c9ea6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bottom_banner.png
// module id = vVcC
// module chunks = 1